<div fxLayout="row" style="min-height: 50px;">
<div fxLayout="col" fxFlex="80%">
<a  href="https://www.lampreysystems.com/" target="_blank" style="bottom:0px;padding-left: 50px;text-decoration: none;">&copy; Copyright {{currentYearLong()}} Lamprey Systems </a>
</div>
<div fxLayout="col" fxFlex="20%">
    Having Troubles?&nbsp;&nbsp;<a href="mailto:support@lampreysystems.com">Email Customer Support</a>
</div>
</div>

